import { getRuntimeConfig } from "~/common/config/runtimeConfig";

export class BatchSizeProvider {
  private sizeIndex = 0;
  private timeoutHandle: null | number = null;
  constructor(private batchSizes: number[]) {}

  getBatchSize() {
    const size = this.batchSizes[this.sizeIndex];
    this.sizeIndex = Math.min(this.sizeIndex + 1, this.batchSizes.length - 1);

    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
    }
    this.timeoutHandle = window.setTimeout(() => (this.sizeIndex = 0), getRuntimeConfig().batching.sizeResetTime);
    return size;
  }
}
